import React from "react";
import styles from "./fba-listings-search-item.module.css";
import ProductImage from "@/components/ProductImage/ProductImage";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import Pill from "@/components/Pill/Pill";
import Button from "@/components/forms/Button/Button";
import IconPlus from "@/components/icons/IconPlus";
import { Product } from "@/contexts/InventoryContext";
import Flex from "@/components/Flex/Flex";
import CopyToClipBoard from "@/components/CopyToClipboard/CopyToClipboard";

type FbaListingsSearchItemProps = {
  product: Product;
  onAddListing: (product: Partial<Product>, sellerItemIndex: number, autofillSKU: string) => void;
  setActiveTab: (tab: "form" | "details" | "offers") => void;
};

const FbaListingsSearchItem = ({
  product,
  onAddListing,
  setActiveTab,
}: FbaListingsSearchItemProps) => {

  const handleOpenFormTab = (index: number = 0, autofillSKU: string = "") => {
    onAddListing({ ...product }, index, autofillSKU);
    setActiveTab("form");
  };

  return (
    <div className={styles.searchItemContainer}>
      <ProductImage imageUrl={product.image} alt={product.name} />

      <Flex className={styles.minWidth0} direction="column" align="start" style={{width:"100%"}}>
        <Flex className={styles.listItemLeftColumn} direction="row" justify="space-between" align="stretch">
          <Tooltip title={product.name}>
            <a className={`strong ${styles.listItemTitle}`} href={`https://www.amazon.com/dp/${product.asin}`} target="_blank">
              {product.name}
            </a>
          </Tooltip>
        </Flex>

        <Flex className={styles.listItemLeftColumn} direction="column" align="start">
          <Flex justify="space-between" align="center" style={{width:"100%"}}>
            <Flex direction="column">
              <CopyToClipBoard value={product.asin} tooltipText="Copy ASIN">
                <Flex align="center">
                  <p className="weak small-text">ASIN:</p>
                  &nbsp;
                  <p className="strong small-text">{product.asin}</p>
                </Flex>
              </CopyToClipBoard>
              {!!product.salesRank && (
                <Flex align="center">
                  <Flex align="center">
                    <p className="weak small-text">Category:</p>
                    &nbsp;
                    <a className="strong small-text" href={product.categoryLink} target="_blank">{product.category}</a>
                  </Flex>
                  <Flex align="center">
                    <p className="weak small-text">&nbsp;· Sales Rank:</p>
                    &nbsp;
                    <p className="strong small-text"><Pill>{product.salesRank.toLocaleString("en-US", { style: "decimal", maximumFractionDigits: 2 })}</Pill></p>
                  </Flex>
                </Flex>
              )}
            </Flex>

            <Button
              type="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenFormTab(0);
              }}
            >
              <Flex gap={0.5} align="center" justify="center">
                <IconPlus />
                New SKU
              </Flex>
            </Button>
          </Flex>
        </Flex> 
      </Flex>
    </div>
  );
};

export default FbaListingsSearchItem;